var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c("div", { staticClass: "dashboard" }, [
      _c("div", { staticClass: "welcome-banner" }, [
        _c("div", { staticClass: "welcome-text" }, [
          _c("h2", [_vm._v("欢迎使用" + _vm._s(_vm.title))]),
          _c("p", [_vm._v("今日是 " + _vm._s(_vm.today))])
        ]),
        _c("div", { staticClass: "welcome-deco" }, [
          _c("i", { staticClass: "fa fa-dragon" })
        ])
      ]),
      _c("div", { staticClass: "quick-section" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("span", { staticClass: "title-deco" }),
          _c("h3", [_vm._v("快捷入口")])
        ]),
        _c(
          "div",
          { staticClass: "quick-grid" },
          _vm._l(_vm.quickActions, function(action) {
            return _c(
              "div",
              {
                key: action.title,
                staticClass: "quick-card",
                on: {
                  click: function($event) {
                    return _vm.handleQuickAction(action)
                  }
                }
              },
              [
                _c("div", { staticClass: "quick-icon" }, [
                  _c("i", { class: action.icon })
                ]),
                _c("div", { staticClass: "quick-info" }, [
                  _c("div", { staticClass: "quick-title" }, [
                    _vm._v(_vm._s(action.title))
                  ]),
                  _c("div", { staticClass: "quick-desc" }, [
                    _vm._v(_vm._s(action.desc))
                  ])
                ]),
                _c("i", { staticClass: "fa fa-arrow-right quick-arrow" })
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }